import React from "react";
import { Shield, Zap, Heart, Settings } from "lucide-react";
const TocTocDifferentials = () => {
  const differentials = [{
    icon: Shield,
    title: "Garantia de Qualidade",
    description: "Se não ficar satisfeito, refazemos o trabalho sem custo adicional",
    features: ["Resultado garantido", "Suporte pós-entrega", "Revisões ilimitadas"]
  }, {
    icon: Zap,
    title: "Agilidade Premium",
    description: "Entrega em até 48h após a sessão fotográfica",
    features: ["Agendamento flexível", "Entrega expressa", "Edição profissional"]
  }, {
    icon: Heart,
    title: "Atendimento Personalizado",
    description: "Cada projeto é único e recebe atenção exclusiva",
    features: ["Consultoria gratuita", "Planejamento estratégico", "Acompanhamento dedicado"]
  }, {
    icon: Settings,
    title: "Tecnologia Avançada",
    description: "Equipamentos de última geração para resultados excepcionais",
    features: ["Câmeras profissionais", "Drones certificados", "Edição especializada"]
  }];
  return <section className="py-16 md:py-24 bg-[#F6E5C9]/30">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#323031] mb-6">
            O que nos torna <span className="text-[#FF5605]">únicos</span>?
          </h2>
          <p className="text-lg text-[#5B5A59] max-w-3xl mx-auto">
            Combinamos técnica, tecnologia e paixão para criar imagens que não apenas 
            mostram, mas vendem o sonho de um novo lar.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {differentials.map((item, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group">
              <div className="flex items-start">
                <div className="w-16 h-16 bg-[#FF5605]/10 rounded-xl flex items-center justify-center mr-6 flex-shrink-0 group-hover:bg-[#FF5605]/20 transition-colors">
                  <item.icon className="h-8 w-8 text-[#FF5605]" />
                </div>
                
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-[#323031] mb-3">
                    {item.title}
                  </h3>
                  
                  
                  
                  <ul className="space-y-2">
                    {item.features.map((feature, idx) => <li key={idx} className="flex items-center text-sm text-[#5B5A59]">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#FF5605] mr-3"></div>
                        {feature}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
        
        {/* Gallery showcase */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-[#323031] mb-8 text-center">
            Nosso portfólio em destaque
          </h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="rounded-xl overflow-hidden group">
              <img src="/lovable-uploads/de23c8d2-05b8-4009-a2bf-1c4637e23daf.png" alt="Fotografia de cozinha moderna em apartamento Balneário Camboriú - Fotografia imobiliária profissional" loading="lazy" width="300" height="128" className="w-full h-32 object-cover group-hover:scale-110 transition-transform duration-300" />
            </div>
            <div className="rounded-xl overflow-hidden group">
              <img src="/lovable-uploads/3194f393-5b96-45db-8785-e619cb0eff32.png" alt="Fotografia de quarto decorado em imóvel Itajaí - Interior design e fotografia de arquitetura" loading="lazy" width="300" height="128" className="w-full h-32 object-cover group-hover:scale-110 transition-transform duration-300" />
            </div>
            <div className="rounded-xl overflow-hidden group">
              <img src="/lovable-uploads/a2abb9ff-ffef-4477-9aea-619cabf9cb31.png" alt="Fotografia de cozinha gourmet em casa Itapema - Fotografia imobiliária de alto padrão SC" loading="lazy" width="300" height="128" className="w-full h-32 object-cover group-hover:scale-110 transition-transform duration-300" />
            </div>
            <div className="rounded-xl overflow-hidden group">
              <img src="/lovable-uploads/22225273-8564-48e3-af04-85aee0bcaa6e.png" alt="Fotografia de salão de festas em edifício Porto Belo - Áreas comuns fotografia imobiliária" loading="lazy" width="300" height="128" className="w-full h-32 object-cover group-hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
          
          <div className="text-center mt-8">
            <button className="text-[#FF5605] font-medium hover:text-[#E14D04] transition-colors">
              Ver portfólio completo →
            </button>
          </div>
        </div>
      </div>
    </section>;
};
export default TocTocDifferentials;